<template>
    <div v-if="!isLoading" class="home wrapper p-t-30-mobile">
        <div v-show="!tickerModal" class="columns is-tablet">
            <div class="column is-12-mobile is-9-widescreen is-9-fullhd p-l-50-fullhd p-r-50-fullhd w-100">
                <div class="is-hidden-tablet mb-4 mt-4 m-t-10-mobile m-b-0-mobile">
                    <div class="box-guide line-height-medium mt-5">
                        <div class="has-text-weight-bold mb-2 text-size-4" style="font-size: 1.25rem;">
                            As featured on MoneyWeek
                        </div>
                        <div class="text-size-3">
                            <a href="/active-vs-passive" target="_blank">Gain insights with our Active vs Passive page</a>
                        </div>
                    </div>
                </div>
                <div class="is-hidden-tablet">
                    <div class="is-flex is-justify-content-center my-2">
                        <div class="has-text-centered mx-4 effect-number">
                            <div class="is-size-4-mobile is-size-3 is-size-3-tablet has-text-weight-bold mb-3 text-line m-b-5-mobile">
                                <span v-show="cntr.f" id="funds-mobile" class="odometer">00,000</span>
                                <span v-show="!cntr.f" class="odometer">{{effectNumber.f ? effectNumber.f.toLocaleString() : '00,000'}}</span>
                            </div>
                            <p class="font-weight-700 is-size-6 is-has-text-nowrap">Funds</p>
                        </div>
                    </div>
                    <div>
                        <h1><span class="number-description">1</span> <span class="ml-2 has-text-weight-bold">Search</span></h1>
                        <h3 class="font-medium is-size-6 is-size-6-tablet has-text-weight-bold-tablet mb-2 m-l-40">
                            <span class="responsive-font-mobile">All funds available to UK retail investors. In one place.</span>
                        </h3>

                        <h1><span class="number-description">2</span> <span class="ml-2 has-text-weight-bold">Compare</span></h1>
                        <h3 class="font-medium is-size-6 is-size-6-tablet has-text-weight-bold-tablet mb-2 m-l-40">
                            <span class="responsive-font-mobile">See the best funds. High returns, low costs, all is revealed.</span>
                        </h3>

                        <h1><span class="number-description">3</span> <span class="ml-2 has-text-weight-bold">Invest</span></h1>
                        <h3 class="font-medium is-size-6 is-size-6-tablet has-text-weight-bold-tablet mb-2 m-l-40">
                            <span class="responsive-font-mobile">You've found a fund, now check your investment options.</span>
                        </h3>

                        <h3 class="font-medium is-size-6 is-size-6-tablet has-text-`weight-bold-tablet mb-3 m-l-40">
                        <span class="is-has-text-nowrap responsive-font-mobile">ETFs, Investment Trusts, Mutual funds...</span><br>
                        <span id="search-funds" class="is-has-text-nowrap responsive-font-mobile">Get started <strong>for free.</strong></span></h3>
                    </div>
                </div>
                <div class="columns mt-5 mb-0 is-hidden-mobile home-description m-t-50-tablet">
                    <div class="column">
                        <h3 class="font-medium is-size-6 is-size-6-tablet has-text-weight-bold-tablet">
                            <h1 class="is-has-text-nowrap responsive-font"><span class="number-description">1</span> <span class="is-uppercase has-text-weight-bold ml-1">search.</span> All funds available to UK retail investors. In one place. </h1>
                            <h1 class="is-has-text-nowrap responsive-font my-3"><span class="number-description">2</span> <span class="is-uppercase has-text-weight-bold ml-1">compare.</span> See the best funds. High returns, low costs, all is revealed. </h1>
                            <h1 class="is-has-text-nowrap responsive-font"><span class="number-description">3</span> <span class="is-uppercase has-text-weight-bold ml-1">invest.</span> You've found a fund, now check your investment options. </h1>
                            <br>
                            <span class="is-has-text-nowrap responsive-font">ETFs, Investment Trusts, Mutual Funds... Your investing journey begins here.<br></span><span class="is-has-text-nowrap responsive-font"> Get started <strong>for free.</strong></span>
                        </h3>
                        <div class="box-guide line-height-medium mt-2">
                            <div class="has-text-weight-bold mb-2 text-size-4" style="font-size: 1.5rem;">
                                As featured on MoneyWeek
                            </div>
                            <div class="text-size-4">
                                <a href="/active-vs-passive" target="_blank">Gain insights with our Active vs Passive page</a>
                            </div>
                        </div>
                    </div>

                    <div class="column is-justify-content-center">
                        <div class="has-text-centered mx-4 effect-number">
                            <div class="is-size-4-mobile is-size-4 is-size-4-tablet has-text-weight-bold mb-1 text-line">
                                <span v-show="!cntr.f" class="line-height-small">{{effectNumber.f ? effectNumber.f.toLocaleString() : '0,000'}}</span>
                                <span v-show="cntr.f" id="funds-tablet" class="odometer"></span>
                            </div>
                            <p class="font-weight-700 is-size-7 is-has-text-nowrap">Funds</p>
                        </div>
                        <div class="has-text-centered has-text-weight-bold is-italic is-size-7 my-2">including</div>
                        <div class="has-text-centered mx-4 effect-number mt-2">
                            <div class="is-size-4-mobile is-size-4 is-size-4-tablet has-text-weight-bold mb-1 text-line">
                                <span v-show="!cntr.its" class="line-height-small">{{effectNumber.its ? effectNumber.its.toLocaleString() : '000'}}</span>
                                <span v-show="cntr.its" id="its-tablet" class="odometer"></span>
                            </div>
                            <p class="font-weight-700 is-size-7 is-has-text-nowrap">ITs</p>
                        </div>
                        <div class="has-text-centered mx-4 effect-number mt-2">
                            <div class="is-size-4-mobile is-size-4 is-size-4-tablet has-text-weight-bold mb-1 text-line">
                                <span v-show="!cntr.etfs" class="line-height-small">{{effectNumber.etfs ? effectNumber.etfs.toLocaleString() : '0,000'}}</span>
                                <span v-show="cntr.etfs" id="etfs-tablet" class="odometer"></span>
                            </div>
                            <p class="font-weight-700 is-size-7 is-has-text-nowrap">ETFs</p>
                        </div>
                    </div>
                </div>

                <div class="has-text-centered" >
                    <button class="is-hidden-tablet button is-primary mb-4 btn-search-funds pulse-button" v-scroll-to="{ el: '#search-funds', duration: 500, }">Search funds...</button>
                </div>
                <div class="is-hidden-tablet">
                    <b-tabs v-model="activeTab" :animated="false" position="is-centered" class="section-searches" expanded>
                        <b-tab-item key="search-keyword" value="search-keyword" class="search-keyword">
                            <template slot="header">
                                <div class="tab-header-left" v-scroll-to="{ el: '#search-funds', duration: 500, }">
                                    <img width="70px" height="70px" src="/img/Search_By_Keyword.png" />
                                    <h4 class="is-size-7 dark-text font-small-mobile" style="white-space: initial;">By
                                        <span class="text-blue" @click="descriptionKeyword=true"> Keyword</span>,
                                        <span class="text-blue" @click="descriptionTicker=true"> Ticker</span> or
                                        <span class="text-blue" @click="descriptionIsin=true">ISIN</span>
                                    </h4>
                                </div>
                            </template>
                            <div>
                                <div class="model top-10" v-if="descriptionKeyword">
                                    <div class="model-head">
                                        <a class="model-close" v-on:click="descriptionKeyword=false"><img src="img/close.png" /></a>
                                    </div>
                                    <div class="model-body center">
                                        <h2>You can search on:</h2>
                                        <ul>
                                            <li>Fund name (Scottish Mortgage …)</li>
                                            <li>Theme (cyber security …)</li>
                                            <li>Asset manager’s name (RWC …)</li>
                                            <li>Portfolio manager’s name (Harry Nimmo …)</li>
                                        </ul>
                                        <p class="m-b-15">etc</p>
                                        <p>
                                            You can also elect to use one of our suggestions (ESG, VCT …)
                                        </p>
                                        <p class="m-t-15"><a class="has-text-underline" href="https://www.youtube.com/watch?v=-lDyWKyHxBI" target="_blank">How to search for funds on Pickafund</a></p>
                                    </div>
                                </div>
                                <div class="model" v-if="descriptionIsin">
                                    <div class="model-head">
                                        <a class="model-close" v-on:click="descriptionIsin=false"><img src="img/close.png" /></a>
                                    </div>
                                    <div class="model-body center">
                                        <h2>What is an ISIN?</h2>
                                        <ul>
                                            <li>ISIN stands for International Securities Identification Number</li>
                                            <li>An ISIN is a unique code that is used to identify a fund's Share Class, it's like a car number plate!</li>
                                            <li>The ISIN can be found on most investor documents</li>
                                        </ul>
                                        <!--<p><strong>Document</strong></p>-->
                                        <div class="is-flex is-justify-content-center">
                                            <img src="img/ISIN.png">
                                        </div>
                                        <p class="m-t-15"><a class="has-text-underline" href="https://www.youtube.com/watch?v=-lDyWKyHxBI" target="_blank">How to search for funds on Pickafund</a></p>
                                    </div>
                                </div>
                                <div class="model top-10" v-if="descriptionTicker">
                                    <div class="model-head">
                                        <a class="model-close" @click="descriptionTicker=false"><img src="img/close.png" /></a>
                                    </div>
                                    <div class="model-body center">
                                        <h2>What is a ticker?</h2>
                                        <ul>
                                            <li>A stock ticker symbol is an arrangement of characters—usually letters—representing publicly-traded securities on an exchange</li>
                                            <li>Investors typically use the ticker to find and place orders on a security</li>
                                        </ul>
                                        <div class="is-flex is-justify-content-center">
                                            <div>Examples include:</div>
                                            <img src="img/Ticker.jpg">
                                        </div>
                                        <p class="m-t-15"><a class="has-text-underline" href="https://www.youtube.com/watch?v=-lDyWKyHxBI" target="_blank">How to search for funds on Pickafund</a></p>
                                    </div>
                                </div>
                                <div @mouseleave="keywordsvisible=false">
                                    <div class="w-100 is-position-relative p-t-15">
                                        <input
                                            @focus="keywordsvisible=true, searchFocused=true"
                                            @keyup.enter="searchType(), keywordsvisible=false"
                                            @input="onSearchInputChange($event), keywordsvisible=true"
                                            type="text"
                                            class="input is-medium search-input w-100"
                                            placeholder="Search">
                                            <button class="go-button is-hidden-mobile button is-primary h-45" @click="searchType">go</button>
                                        <b-field>
                                            <div  v-if="keywordsvisible" class="is-relativex">
                                                <div class="searchboxx">
                                                    <template v-if="searchText.length > 1">
                                                        <div class="searchitem" @click="keywordsvisible=false, i.type== 'category'  ? searchCategory(i) : keywordSearch(i)" v-for="(i, index) in suggestions.sort((a, b) => a.display.localeCompare(b.display))" :key="index">{{ i.display }}</div>
                                                    </template>
                                                    <template v-if="searchText.length === 0">
                                                        <div class="searchitem" @click="keywordsvisible=false, i.type== 'category'  ? searchCategory(i) : search({...i, source: 1})" v-for="(i, index) in myHist" :key="index" style="color: #009BDE">{{ i.text.toLowerCase() }}</div>
                                                    </template>
                                                </div>
                                            </div>
                                        </b-field>
                                    </div>
                                    <div class="has-text-right pl-0">
                                        <button class="is-hidden-tablet button is-primary mt-2" @click="searchType">go</button>
                                    </div>
                                </div>
                            </div>
                        </b-tab-item>
                        <b-tab-item key="search-category" value="search-category" class="search-category">
                            <template slot="header">
                                <div class="tab-header-right" v-scroll-to="{ el: '#search-funds', duration: 500, }">
                                    <img width="70px" height="70px" src="/img/Search_By_Category.png" />
                                    <h4 class="is-size-7 dark-text font-small-mobile caption-category-mb">By Category</h4>
                                </div>
                            </template>
                            <div>
                                <div class="search-home-wrapper">
                                    <div class="buttons-home-sticky">
                                        <div class="mb-3 is-flex is-justify-content-center has-text-centered is-hidden-tablet">
                                            <button @click="clearCategories" class="button btn-clear no-border font-super-small">clear CHOICES</button>
                                            <button @click="categorySubmit" class="m-l-10 button is-primary font-super-small" style="padding: 0 10px !important;">
                                                <template v-if="catL > 0">see {{$store.state.search.homeCount}} funds</template>
                                                <template v-else>Select Categories</template>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="columns is-multiline">
                                        <div class="column is-4 p-b-0-mobile" >
                                            <category-search
                                                :name="'Fund Type'"
                                                :code="'fund'"
                                                :clear="clear"
                                                :tt="''"
                                                v-on:category-selection="categorySelection"
                                                v-on:category-vals="categoryVals"
                                            />
                                            <category-search
                                                :name="'Region | Country'"
                                                :code="'region'"
                                                :clear="clear"
                                                :tt="''"
                                                v-on:category-selection="categorySelection"
                                                v-on:category-vals="categoryVals"
                                            />
                                            <category-search
                                                :name="'Alternative Strategy'"
                                                :code="'strat'"
                                                :clear="clear"
                                                :tt="''"
                                                v-on:category-selection="categorySelection"
                                                v-on:category-vals="categoryVals"
                                            />
                                            <hr class="hr-gray is-hidden-tablet my-2">
                                        </div>
                                        <div class="column is-4 p-b-0-mobile" >
                                            <category-search
                                                :name="'Investment Style'"
                                                :code="'inv'"
                                                :clear="clear"
                                                :tt="''"
                                                v-on:category-selection="categorySelection"
                                                v-on:category-vals="categoryVals"
                                            />
                                            <category-search
                                                :name="'Sector'"
                                                :code="'sector'"
                                                :clear="clear"
                                                :tt="''"
                                                v-on:category-selection="categorySelection"
                                                v-on:category-vals="categoryVals"
                                            />
                                            <category-search
                                                :name="'Market Cap'"
                                                :code="'stock'"
                                                :clear="clear"
                                                :tt="''"
                                                v-on:category-selection="categorySelection"
                                                v-on:category-vals="categoryVals"
                                            />
                                            <hr v-if="Object.keys(this.$store.state.search.homeCategoryList).length>2" class="hr-gray is-hidden-tablet my-2">
                                        </div>
                                        <div class="column is-4 " >
                                            <category-search
                                                :name="'Currency'"
                                                :code="'currency'"
                                                :clear="clear"
                                                :tt="''"
                                                v-on:category-selection="categorySelection"
                                                v-on:category-vals="categoryVals"
                                            />
                                            <category-search
                                                :name="'Bond Type'"
                                                :code="'bond'"
                                                :clear="clear"
                                                :tt="''"
                                                v-on:category-selection="categorySelection"
                                                v-on:category-vals="categoryVals"
                                            />
                                            <category-search
                                                :name="'Maturity'"
                                                :code="'maturity'"
                                                :clear="clear"
                                                :tt="''"
                                                v-on:category-selection="categorySelection"
                                                v-on:category-vals="categoryVals"
                                            />
                                        </div>

                                    </div>
                                </div>

                                <div class="mb-5 is-flex is-justify-content-flex-end  has-text-right is-hidden-mobile">
                                    <button @click="clearCategories" class="button btn-clear no-border">clear CHOICES</button>
                                    <button @click="categorySubmit" class="m-l-10 button is-primary">
                                        <template v-if="catL > 0">see {{$store.state.search.homeCount}} funds</template>
                                        <template v-else>Select Categories</template>
                                    </button>

                                </div>
                            </div>
                        </b-tab-item>
                    </b-tabs>
                </div>
                <div class="is-hidden-mobile">
                    <h2 class="is-size-5 is-size-4-tablet has-text-weight-bold m-b-10 m-t-40-tablet" id="search-funds-section">Search funds by
                        <span class="has-text-weight-light has-text-weight-bold">
                            <a style="text-decoration: underline;" @click="descriptionKeyword=true"> Keyword</a>,
                            <a style="text-decoration: underline;" @click="descriptionTicker=true">Ticker</a> or
                            <a style="text-decoration: underline;" @click="descriptionIsin=true">ISIN</a>

                        </span>
                    </h2>
                    <div class="model top-10" v-if="descriptionKeyword">
                        <div class="model-head">
                            <a class="model-close" v-on:click="descriptionKeyword=false"><img src="img/close.png" /></a>
                        </div>
                        <div class="model-body center">
                            <h2>You can search on:</h2>
                            <ul>
                                <li>Fund name (Scottish Mortgage …)</li>
                                <li>Theme (cyber security …)</li>
                                <li>Asset manager’s name (RWC …)</li>
                                <li>Portfolio manager’s name (Harry Nimmo …)</li>
                            </ul>
                            <p class="m-b-15">etc</p>
                            <p>
                                You can also elect to use one of our suggestions (ESG, VCT …)
                            </p>
                            <p class="m-t-15"><a class="has-text-underline" href="https://www.youtube.com/watch?v=-lDyWKyHxBI" target="_blank">How to search for funds on Pickafund</a></p>
                        </div>
                    </div>

                    <div class="model top-10" v-if="descriptionIsin">
                        <div class="model-head">
                            <a class="model-close" @click="descriptionIsin=false"><img src="img/close.png" /></a>
                        </div>
                        <div class="model-body center">
                            <h2>What is an ISIN?</h2>
                            <ul>
                                <li>ISIN stands for International Securities Identification Number</li>
                                <li>An ISIN is a unique code that is used to identify a fund's Share Class, it's like a car number plate!</li>
                                <li>The ISIN can be found on most investor documents</li>
                            </ul>
                            <!--<p><strong>Document</strong></p>-->
                            <div class="is-flex is-justify-content-center">
                                <img src="img/ISIN.png">
                            </div>
                            <p class="m-t-15"><a class="has-text-underline" href="https://www.youtube.com/watch?v=-lDyWKyHxBI" target="_blank">How to search for funds on Pickafund</a></p>
                        </div>
                    </div>

                    <div @mouseleave="keywordsvisible=false">
                        <div class="w-100 is-position-relative">
                            <input
                                @focus="keywordsvisible=true, searchFocused=true"
                                @keyup.enter="searchType(), keywordsvisible=false"
                                @input="onSearchInputChange($event), keywordsvisible=true"
                                v-model="searchText"
                                type="text"
                                class="input is-medium search-input w-100"
                                placeholder="Search">
                                <button class="go-button is-hidden-mobile button is-primary h-45" @click="searchType">go</button>
                            <b-field>
                                <div  v-if="keywordsvisible" class="is-relativex">
                                    <div class="searchboxx">
                                        <template v-if="searchText.length > 1">
                                            <div class="searchitem" @click="keywordsvisible=false, i.type== 'category'  ? searchCategory(i) : keywordSearch(i)" v-for="(i, index) in suggestions" :key="index">{{ i.display }}</div>
                                        </template>
                                        <template v-if="searchText.length === 0">
                                            <div class="searchitem" @click="keywordsvisible=false, i.type== 'category'  ? searchCategory(i) : search({...i, source: 1}), searchItemText=i.text" v-for="(i, index) in myHist" :key="index" style="color: #009BDE">{{ i.text.toLowerCase() }}</div>
                                        </template>
                                    </div>
                                </div>
                            </b-field>
                        </div>
                        <div class="has-text-right pl-0">
                            <button class="is-hidden-tablet button is-primary mt-2" @click="searchType">go</button>
                        </div>
                    </div>

                    <div class="model top-10" v-if="descriptionTicker">
                        <div class="model-head">
                            <a class="model-close" v-on:click="descriptionTicker=false"><img src="img/close.png" /></a>
                        </div>
                        <div class="model-body center">
                            <h2>What is a ticker?</h2>
                            <ul>
                                <li>A stock ticker symbol is an arrangement of characters—usually letters—representing publicly-traded securities on an exchange</li>
                                <li>Investors typically use the ticker to find and place orders on a security</li>
                            </ul>
                            <div class="is-flex is-justify-content-center">
                                <div>Examples include:</div>
                                <img src="img/Ticker.jpg">
                            </div>
                            <p class="m-t-15"><a class="has-text-underline" href="https://www.youtube.com/watch?v=-lDyWKyHxBI" target="_blank">How to search for funds on Pickafund</a></p>
                        </div>
                    </div>

                    <h2 class="is-size-5 is-size-4-tablet has-text-weight-bold m-b-40 m-b-10-tablet m-t-50">Search funds by 
                        <a style="text-decoration: underline;" href="/pages/fund-category-definitions" target="_blank">Category</a>
                    </h2>
                    <div class="search-home-wrapper">
                        <div class="buttons-home-sticky">
                            <div class="mb-3 is-flex is-justify-content-flex-end has-text-centered is-hidden-tablet">
                                <button @click="clearCategories" class="button btn-clear no-border">clear CHOICES</button>
                                <button @click="categorySubmit" class="m-l-10 button is-primary">
                                    <template v-if="catL > 0">see {{$store.state.search.homeCount}} funds</template>
                                    <template v-else>Select Categories</template>
                                </button>
                            </div>
                        </div>

                        <div class="columns is-multiline">
                            <div class="column is-4 p-b-0-mobile" >
                                <category-search
                                    :name="'Fund Type'"
                                    :code="'fund'"
                                    :clear="clear"
                                    :tt="''"
                                    v-on:category-selection="categorySelection"
                                    v-on:category-vals="categoryVals"
                                />
                                <category-search
                                    :name="'Region | Country'"
                                    :code="'region'"
                                    :clear="clear"
                                    :tt="''"
                                    v-on:category-selection="categorySelection"
                                    v-on:category-vals="categoryVals"
                                />
                                <category-search
                                    :name="'Alternative Strategy'"
                                    :code="'strat'"
                                    :clear="clear"
                                    :tt="''"
                                    v-on:category-selection="categorySelection"
                                    v-on:category-vals="categoryVals"
                                />
                                <hr class="hr-gray is-hidden-tablet my-2">
                            </div>
                            <div class="column is-4 p-b-0-mobile" >
                                <category-search
                                    :name="'Investment Style'"
                                    :code="'inv'"
                                    :clear="clear"
                                    :tt="''"
                                    v-on:category-selection="categorySelection"
                                    v-on:category-vals="categoryVals"
                                />
                                <category-search
                                    :name="'Sector'"
                                    :code="'sector'"
                                    :clear="clear"
                                    :tt="''"
                                    v-on:category-selection="categorySelection"
                                    v-on:category-vals="categoryVals"
                                />
                                <category-search
                                    :name="'Market Cap'"
                                    :code="'stock'"
                                    :clear="clear"
                                    :tt="''"
                                    v-on:category-selection="categorySelection"
                                    v-on:category-vals="categoryVals"
                                />
                                <hr class="hr-gray is-hidden-tablet my-2">
                            </div>
                            <div class="column is-4 " >
                                <category-search
                                    :name="'Currency'"
                                    :code="'currency'"
                                    :clear="clear"
                                    :tt="''"
                                    v-on:category-selection="categorySelection"
                                    v-on:category-vals="categoryVals"
                                />
                                <category-search
                                    :name="'Bond Type'"
                                    :code="'bond'"
                                    :clear="clear"
                                    :tt="''"
                                    v-on:category-selection="categorySelection"
                                    v-on:category-vals="categoryVals"
                                />
                                <category-search
                                    :name="'Maturity'"
                                    :code="'maturity'"
                                    :clear="clear"
                                    :tt="''"
                                    v-on:category-selection="categorySelection"
                                    v-on:category-vals="categoryVals"
                                />
                            </div>

                        </div>
                    </div>
                    <div class="mt-3 mb-5 is-flex is-justify-content-flex-end  has-text-right is-hidden-mobile">
                        <button @click="clearCategories" class="button btn-clear no-border">clear CHOICES</button>
                        <button @click="categorySubmit" class="m-l-10 button is-primary">
                            <template v-if="catL > 0">see {{$store.state.search.homeCount}} funds</template>
                            <template v-else>Select Categories</template>
                        </button>
                    </div>
                </div>
                <div class="is-hidden-mobile columns is-align-items-stretch is-size-5 has-text-weight-bold toggle-category">
                    <div class="column is-6"></div>
                    <div class="column is-6">
                        <label class="is-flex is-flex mt-1 is-align-items-center">
                        <span class="mr-3">Top</span>
                            <b-field v-tooltip="'See Top or Worst Performing Categorires'">
                                <b-switch
                                    v-model="showTopCategory"
                                >
                                </b-switch>
                            </b-field>
                            Worst
                        </label>
                    </div>
                </div>
                <div class="is-hidden-mobile columns is-align-items-stretch" id="top-performing">
                    <div class="wrapper-title column is-6">
                        <div class="top-title is-size-5 has-text-weight-bold m-b-5 line-height-medium">
                            Top performing funds
                        </div>
                        <div class="text-grey sub-title">* only funds with £50m+ net assets</div>
                        <div class="text-grey sub-title is-hidden-mobile">&nbsp;</div>
                    </div>
                    <div v-show="showTopCategory || isBannerMobile" class="wrapper-title column is-6">
                        <div class="top-title is-size-5 has-text-weight-bold m-b-5 line-height-medium">
                            Top performing categories
                        </div>
                        <div class="text-grey sub-title">* only categories with 3+ funds</div>
                        <div class="text-grey sub-title">* median used</div>
                    </div>
                    <div v-show="!showTopCategory || isBannerMobile" class="wrapper-title column is-6">
                        <div class="top-title is-size-5 has-text-weight-bold m-b-5 line-height-medium">
                            Worst performing categories
                        </div>
                        <div class="text-grey sub-title">* only categories with 3+ funds</div>
                        <div class="text-grey sub-title">* median used</div>
                    </div>
                </div>
                <div class="columns is-tablet is-align-items-stretch wrapper-top-funds">
                    <div id="top-5-funds" class="column is-6 p-t-0">
                        <div class="wrapper-title is-hidden-tablet m-t-30">
                            <div class="top-title is-size-5 has-text-weight-bold m-b-5 line-height-medium">
                                Top Performing Funds
                            </div>
                            <div class="text-grey sub-title">* only funds with £50m+ net assets</div>
                            <div class="text-grey sub-title is-hidden-mobile">&nbsp;</div>
                        </div>
                        <TopList @sortList="renderListFunds" @goToLink="handlerGoToLink" :list='listFunds' title='Top Funds' limit=5 type="isin" backgroundColor="#b9ede8"/>
                        <TopList id="top-investment-trusts" @sortList="renderListFunds" @goToLink="handlerGoToLink" :list='ListTopInvestment' title='Top Investment Trusts' limit=5 type="isin" keyword='Closed Ended Investment Company' backgroundColor="#ebd5e5"/>
                        <TopList id="top-etfs" @sortList="renderListFunds" @goToLink="handlerGoToLink" :list='listTopETFs' title='Top ETFs' limit=5 type="isin" keyword='etf' backgroundColor="#d0fcd2"/>
                        <TopList id="top-mutual-funds" @sortList="renderListFunds" @goToLink="handlerGoToLink" :list='listTopMutual' title='Top Mutual Funds' limit=5 subTitle='*covered by the IA' type="isin" keyword='funds covered by the IA (Investment Association)' backgroundColor="#ffffcc"/>
                    </div>
                    <div v-show="showTopCategory || isBannerMobile" id="category-5-funds" class="column is-6 p-t-0">
                        <div class="wrapper-title is-hidden-tablet m-t-20">
                            <div class="top-title is-size-5 has-text-weight-bold m-b-5 line-height-medium">
                                Top performing categories
                            </div>
                            <div class="text-grey sub-title">* only categories with 3+ funds</div>
                            <div class="text-grey sub-title">* median used</div>
                        </div>
                        <TopList @sortList="renderListCategoryMs" @goToLink="handlerGoToLink" :list='listCategoryMs' title='Top Categories' limit=5 type="category" keyword='all' backgroundColor="#b9ede8"/>
                        <TopList id="top-equity" @sortList="renderListCategoryMs" @goToLink="handlerGoToLink" :list='listCategoryEquity' title='Top Equity' limit=5 type="category" keyword='equity' backgroundColor="#ebd5e5"/>
                        <TopList id="top-bond" @sortList="renderListCategoryMs" @goToLink="handlerGoToLink" :list='listCategoryBond' title='Top Bond' limit=5 type="category" keyword='bond' backgroundColor="#d0fcd2"/>
                        <TopList id="top-alternative" @sortList="renderListCategoryMs" @goToLink="handlerGoToLink" :list='listCategoryAlternative' title='Top Alternative' limit=5 type="category" keyword='alternative' backgroundColor="#ffffcc"/>
                    </div>
                    <div v-show="!showTopCategory || isBannerMobile" id="category-5-funds" class="column is-6 p-t-0">
                        <div class="wrapper-title is-hidden-tablet m-t-20">
                            <div class="top-title is-size-5 has-text-weight-bold m-b-5 line-height-medium">
                                Worst performing categories
                            </div>
                            <div class="text-grey sub-title">* only categories with 3+ funds</div>
                            <div class="text-grey sub-title">* median used</div>
                        </div>
                        <TopList @sortList="renderListCategoryMs" @goToLink="handlerGoToLink" :list='listCategoryMsWorst' title='Worst Categories' limit=5 type="category" worst=true keyword='all' backgroundColor="#b9ede8"/>
                        <TopList @sortList="renderListCategoryMs" @goToLink="handlerGoToLink" :list='listCategoryEquityWorst' title='Worst Equity' limit=5 type="category" worst=true keyword='equity' backgroundColor="#ebd5e5"/>
                        <TopList @sortList="renderListCategoryMs" @goToLink="handlerGoToLink" :list='listCategoryBondWorst' title='Worst Bond' limit=5 type="category" worst=true keyword='bond' backgroundColor="#d0fcd2"/>
                        <TopList @sortList="renderListCategoryMs" @goToLink="handlerGoToLink" :list='listCategoryAlternativeWorst' title='Worst Alternative' limit=5 type="category" worst=true keyword='alternative' backgroundColor="#ffffcc"/>
                    </div>
                </div>

                <div class="popular-searches mb-5">
                    <h3 id="top-money-market" class="top-title is-size-4 has-text-weight-bold line-height-medium mb-0">Top Money Market and Ultra-Short Term Bond funds</h3>
                    <div class="text-grey sub-title">* only funds with £100m+ net assets</div>
                    <div class="text-grey sub-title">* only funds available on more than 1 platform</div>
                    <div class="text-grey sub-title m-b-20 ">* for USD & EUR returns have been translated into GBP</div>
                    <div class="is-tablet columns">
                        <div style="padding: 0.75rem" class="column is-4">
                            <TopList @sortList="renderTopMoneyMarket" @goToLink="handlerGoToLink" :list='listTopMoneyMarketGBP' title='GBP' limit=5 type="isin" keyword='GBP' backgroundColor="#b9ede8"/>
                        </div>
                         <div style="padding: 0.75rem" class="column is-4">
                            <TopList @sortList="renderTopMoneyMarket" @goToLink="handlerGoToLink" :list='listTopMoneyMarketUSD' title='USD' limit=5 type="isin" keyword='USD' backgroundColor="#ebd5e5"/>
                        </div>
                         <div style="padding: 0.75rem" class="column is-4">
                            <TopList @sortList="renderTopMoneyMarket" @goToLink="handlerGoToLink" :list='listTopMoneyMarketEUR' title='EUR' limit=5 type="isin" keyword='EUR' backgroundColor="#d0fcd2"/>
                        </div>

                    </div>
                </div>

                <div class="popular-searches mb-5">
                    <h3 class="m-b-20 top-title is-size-4 has-text-weight-bold line-height-medium">Common searches</h3>
                    <div class="is-tablet columns" style="margin-left: -0.25rem; margin-right: -0.25rem;">
                        <div style="padding: 0.75rem 0.25rem" class="column is-3">
                            <div class="bl fund-card" style="background: rgb(255, 255, 204);">
                                <p class="has-text-weight-bold m-l-15 m-b-10">In the news</p>
                                <ul>
                                    <li><span @click='keywordSearch({search: "ai artificial intelligence robotics automation", display: "AI, Robotics & Automation", code: "AI, Robotics & Automation"})'>AI / Robotics / Automation</span></li>
                                    <li><span @click='keywordSearch({search: "s&p 500 s&p500", display: "S&P 500 index trackers", code: "S&P 500 index trackers"})'>S&P 500 index trackers</span></li>
                                    <li><span @click='keywordSearch({search: "gold bullion", display: "Gold Funds", code: "Gold funds"})'>Gold</span></li>
                                    <li><span @click='keywordSearch({search: "bitcoin btc", display: "Bitcoin funds (BTC)", code: "Bitcoin funds"})'>Bitcoin</span></li>
                                    <li><span @click='keywordSearch({search: "tips", display: "US TIPS", code: "US TIPS"})'>US Tips</span></li>
                                </ul>
                            </div>
                        </div>
                        <div style="padding: 0.75rem 0.25rem" class="column is-3">
                            <div class="bl fund-card" style="background: rgb(185, 237, 232);">
                                <p class="has-text-weight-bold m-l-15 m-b-10"> Broad</p>
                                <ul v-if="listBroad.length > 0">
                                    <li v-for="(item, index) in listBroad" :key="item+index"><span @click="commonSearchBroad(item)">{{item.text}}</span></li>
                                </ul>
                            </div>
                        </div>
                        <div style="padding: 0.75rem 0.25rem" class="column is-3">
                            <div class="bl fund-card" style="background: rgb(235, 213, 229);">
                                <p class="has-text-weight-bold m-l-15 m-b-10">Equity</p>
                                <ul v-if="listEquity.length > 0">
                                    <li v-for="(item, index) in listEquity" :key="item+index"><span @click="categoryLink(item.text, item.code)">{{item.text}}</span></li>
                                </ul>
                                <ul v-else>
                                    <li><span @click="categoryLink('Equity / US / Growth',[ 'EUCA000527' ])">Equity / US / Growth</span></li>
                                    <li><span @click="categoryLink('Equity / Technology',[ 'EUCA000542' ])">Equity / Technology </span></li>
                                    <li><span @click="categoryLink('Equity / UK / Income',[ 'EUCA000846' ])">Equity / UK / Income </span></li>
                                    <li><span @click="categoryLink('Equity / Healthcare',[ 'EUCA000537' ])">Equity / Healthcare </span></li>
                                    <li><span @click="categoryLink('Equity / Global / Income',[ 'EUCA000876' ])">Equity / Global / Income </span></li>
                                </ul>
                            </div>
                        </div>
                        <div style="padding: 0.75rem 0.25rem" class="column is-3">
                            <div class="bl fund-card" style="background: rgb(208, 252, 210);">
                                <p class="has-text-weight-bold m-l-15 m-b-10"> Bond</p>
                                <ul v-if="listBonds.length > 0">
                                    <li v-for="(item, index) in listBonds" :key="item+index"><span @click="categoryLink(item.text, item.code)">{{item.text}}</span></li>
                                </ul>
                                <ul v-else>
                                    <li><span @click="categoryLink('Bonds / Global / High yield',[ 'EUCA000766', 'EUCA000854', 'EUCA000855' ])">Bonds / Global / High yield </span></li>
                                    <li><span @click="categoryLink('Bonds / GBP / Corporate',[ 'EUCA000692','EUCA001001' ])">Bonds / GBP / Corporate </span></li>
                                    <li><span @click="categoryLink('Bonds / GBP / Government',[ 'EUCA000606' ])">Bonds / GBP / Government </span></li>
                                    <li><span @click="categoryLink('Convertible Bonds / Global',[ 'EUCA000749','EUCA000750','EUCA000823' ])">Convertible Bonds / Global </span></li>
                                    <li><span @click="categoryLink('Bonds / USD / Corporate',[ 'EUCA000691' ])">Bonds / USD / Corporate </span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <h3 class="m-b-20 top-title is-size-4 has-text-weight-bold line-height-medium">Useful resources</h3>
                    <div v-if="fltguides.length || fltotherusefulres.length || fromPartners.length || fltvideos.length" class="bl useful-resources fund-card" style="background: rgb(0,0,0);">
                        <h3 v-if="fltguides.length > 0" class="m-b-0 top-title is-size-4 has-text-weight-bold line-height-medium has-text-white">Guides:</h3>
                        <ul v-if="fltguides.length > 0">
                            <li v-for="(item, index) in fltguides" :key="item+index">
                                <a :href="item.url" target="_blank">
                                    <span>{{item.title}}</span>
                                </a>
                            </li>
                        </ul>
                        <h3 v-if="fltotherusefulres.length > 0" class="m-b-0 m-t-30 top-title is-size-4 has-text-weight-bold line-height-medium has-text-white">Tools & Insights:</h3>
                        <ul v-if="fltotherusefulres.length > 0">
                            <li>
                                <router-link :to="'/pages/fund-investing-glossary'">
                                    <span>Glossary</span>
                                </router-link>
                            </li>
                            <li v-for="(item, index) in fltotherusefulres" :key="item+index">
                                <a :href="item.url">
                                    <span>{{item.title}}</span>
                                </a>
                            </li>
                        </ul>
                        <h3 v-if="fromPartners.length > 0" class="m-b-0 m-t-30 top-title is-size-4 has-text-weight-bold line-height-medium has-text-white">Press, Media & Socials:</h3>
                        <ul v-if="fromPartners.length > 0">
                            <li v-for="(item, index) in fromPartners" :key="item+index">
                                <a :href="item.url" target="_blank">
                                    <span>{{item.title}}</span>
                                </a>
                            </li>
                        </ul>
                        <h3 v-if="fltvideos.length > 0" class="m-b-0 m-t-30 top-title is-size-4 has-text-weight-bold line-height-medium has-text-white">Video Tutorials:</h3>
                        <ul v-if="fltvideos.length > 0">
                            <li v-for="(item, index) in fltvideos" :key="item+index">
                                <a :href="item.url" target="_blank">
                                    <span>{{item.title}}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="columns m-t-30 wrapper-social">
                    <div class="column is-12-mobile is-6">
                        <div class="wrapper-news">
                            <div class="has-text-weight-bold title-news">
                                <a class="has-text-white" href="/fund-news-recap/">Fund News Recap</a>
                            </div>
                            <div class="sections" v-if="fundNews">
                                <div class="wrapper-body">
                                    <div class="wrapper-content">
                                        <HomeFundNewsCard v-for="news in fundNews" :key="news.id" :news="news"></HomeFundNewsCard>
                                    </div>
                                    <router-link :to="{path:'/fund-news-recap/'}">
                                        <div class="btn-view-more">View More</div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-12-mobile is-6">
                        <div class="wrapper-blog">
                            <div class="has-text-weight-bold title-blog">
                                <a class="has-text-white" href="/blog/">Posts from Pickafund blog</a>
                            </div>
                            <div class="sections" v-if="blogData">
                                <div class="wrapper-body">
                                    <div class="wrapper-content">
                                        <HomeBlogCard v-for="(i, index) in blogData.data" :key="index" v-show="index < 3" :blog="i"></HomeBlogCard>
                                    </div>
                                    <router-link :to="{path:'/blog/'}">
                                        <div class="btn-view-more">View More</div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-t-30" style="background-color: #000093; padding: 1rem">
                    <div class="top-title is-size-5 has-text-weight-bold m-b-20 line-height-medium" style="color:#fff">What's our community saying?..</div>
                    <div class="is-hidden-mobile is-flex mb-5 testimonials">
                        <div style="flex:1" v-for="(i, index) in testimonials.slice(0,4)" :key="index" >
                            <div class="is-flex is-flex-direction-column">
                                <div>
                                    <div class="m-b-10">
                                        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                            width="35px" height="28px" viewBox="0 0 333.000000 268.000000"
                                            preserveAspectRatio="xMidYMid meet">
                                            <g transform="translate(0.000000,268.000000) scale(0.100000,-0.100000)"
                                            fill="#fff" stroke="none">
                                            <path d="M1185 2641 c-166 -80 -418 -258 -585 -414 -318 -298 -489 -590 -571
                                            -977 -30 -139 -32 -372 -6 -505 48 -237 123 -380 281 -538 148 -147 274 -202
                                            461 -201 128 0 207 18 310 69 190 93 269 242 270 505 0 97 -4 137 -19 180 -47
                                            138 -108 217 -207 270 -106 56 -141 62 -406 67 l-242 5 -7 35 c-14 74 3 206
                                            42 322 63 192 170 355 353 544 128 131 226 216 420 362 96 73 147 118 149 132
                                            4 25 -23 79 -67 141 -40 54 -68 55 -176 3z"/>
                                            <path d="M3085 2641 c-166 -80 -418 -258 -585 -414 -318 -298 -489 -590 -571
                                            -977 -30 -139 -32 -372 -6 -505 48 -237 123 -380 281 -538 148 -147 274 -202
                                            461 -201 128 0 207 18 310 69 190 93 269 242 270 505 0 97 -4 137 -19 180 -47
                                            138 -108 217 -207 270 -106 56 -141 62 -406 67 l-242 5 -7 35 c-14 74 3 206
                                            42 322 63 192 170 355 353 544 128 131 226 216 420 362 96 73 147 118 149 132
                                            4 25 -23 79 -67 141 -40 54 -68 55 -176 3z"/>
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="testimonials-desc line-height-medium mb-5">
                                        {{i.desc}}
                                    </div>
                                </div>
                                <div>
                                    <div class="testimonials-name has-text-weight-bold m-b-2">
                                        ~{{i.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wrapper-testimonials mb-5 is-hidden-tablet">
                        <carousel :paginationColor="red" :paginationActiveColor="yellow" :perPageCustom="[[0, 1], [768, 4]]">
                            <slide v-for="(i, index) in testimonials" :key="index">
                                <div class="is-flex is-flex-direction-column">
                                    <div>
                                        <div class="m-b-10">
                                            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                                                width="50px" height="40px" viewBox="0 0 333.000000 268.000000"
                                                preserveAspectRatio="xMidYMid meet">
                                                <g transform="translate(0.000000,268.000000) scale(0.100000,-0.100000)"
                                                fill="#fff" stroke="none">
                                                <path d="M1185 2641 c-166 -80 -418 -258 -585 -414 -318 -298 -489 -590 -571
                                                -977 -30 -139 -32 -372 -6 -505 48 -237 123 -380 281 -538 148 -147 274 -202
                                                461 -201 128 0 207 18 310 69 190 93 269 242 270 505 0 97 -4 137 -19 180 -47
                                                138 -108 217 -207 270 -106 56 -141 62 -406 67 l-242 5 -7 35 c-14 74 3 206
                                                42 322 63 192 170 355 353 544 128 131 226 216 420 362 96 73 147 118 149 132
                                                4 25 -23 79 -67 141 -40 54 -68 55 -176 3z"/>
                                                <path d="M3085 2641 c-166 -80 -418 -258 -585 -414 -318 -298 -489 -590 -571
                                                -977 -30 -139 -32 -372 -6 -505 48 -237 123 -380 281 -538 148 -147 274 -202
                                                461 -201 128 0 207 18 310 69 190 93 269 242 270 505 0 97 -4 137 -19 180 -47
                                                138 -108 217 -207 270 -106 56 -141 62 -406 67 l-242 5 -7 35 c-14 74 3 206
                                                42 322 63 192 170 355 353 544 128 131 226 216 420 362 96 73 147 118 149 132
                                                4 25 -23 79 -67 141 -40 54 -68 55 -176 3z"/>
                                                </g>
                                            </svg>
                                        </div>
                                        <div class="testimonials-desc line-height-medium mb-5">
                                            {{i.desc}}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="testimonials-name has-text-weight-bold m-b-2">
                                            ~{{i.name}}
                                        </div>
                                    </div>
                                </div>
                            </slide>
                        </carousel>
                    </div>
                </div>

                <div v-if="isBannerMobile" class="column is-12-mobile is-3-widescreen banner-home is-hidden-tablet">
                    <div class="banner-on-top">
                        <AdsGoogle />
                    </div>
                </div>
                <div class="columns is-12-tablet is-mobile">
                    <div class="column disclaimer">
                        <Disclaimer />
                    </div>
                </div>
            </div>
            <div v-if="!isBannerMobile" ref="subRight_before" class="column is-12-mobile is-3-widescreen banner-home is-hidden-mobile p-x-0">
                <div class="banner-on-top" ref="subRight">
                    <!-- <AdsGoogle /> -->
                    <AdsPartner />  
                </div>
            </div>
        </div>
        <b-modal
            v-model="tickerModal"
            has-modal-card
            trap-focus
            :destroy-on-hide="false"
            aria-role="dialog"
            aria-label="Ticker Modal"
            aria-modal>
            <template >
                <div class="modal-card" style="width: auto;">
                    <section class="modal-card-body line-height-medium py-5 px-6 has-text-centered is-size-6 is-size-4-tablet">
                        <button
                            type="button"
                            class="delete"
                            @click="tickerModal=false"/>
                            <div>Would you like to see</div>
                            <a class="py-2 is-block" @click="search({
                                type: 'text',
                                text: searchText,
                                code: null,
                                source: 1,
                                tickerShow: false,
                                clickOption: 'ticker'})"
                            >
                            {{ $store.state.search.searchData.ticker_search
                                && $store.state.search.searchData.ticker_search.data[0].FundBasicsName }}
                            </a>
                            <div><b>OR</b></div>
                            <a class="py-2 is-block"
                                @click="search({
                                    type: 'text',
                                    text: searchText ? convertURL(searchText.replaceAll('/', '*')) : 'All',
                                    code: null,
                                    source: 1,
                                    tickerShow: false,
                                    clickOption: 'text'})"
                            >results of text search on "{{ searchText ||  searchItemText }}"</a>
                    </section>
                </div>
            </template>
        </b-modal>
    </div>
    <div class="preloader-center" v-else>
        <Preloader />
    </div>
</template>
<style scoped>
.toggle-category .switch {
    margin-right: 0;
}
.toggle-category .switch::v-deep .check, .toggle-category .switch::v-deep:hover .check {
    background-color: red;
    transform: rotate(180deg);
}
.fund-card {
  border: 1px solid #4f81bd;
  padding: 15px;
  border-radius: 20px;
  box-shadow: 0px 2px 4px #4f81bd;
}
.btn-view-more {
    color: #4173ea;
    text-align: center;
    font-weight: 500;
    font-size: 16px;
    margin: 20px 0;
}
.box-guide {
    background: #000;
    border-radius: 5px;
    border: 5px solid #4177ea;
    color: #fff;
    padding: 10px;
}
.text-size-1 {
    font-size: 14px;
}
.text-size-2 {
    font-size: 12px;
    a:hover {
        color: white;
    }
}
.text-size-3 {
    font-size: 16px;
    a:hover {
        color: white;
    }
}
.top-title {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}
.sub-title {
    line-height: 20px;
}

@media (max-width: 768px) {
    .wrapper-title {
        height: auto;
    }
    .sub-title {
        height: auto;
    }
}
.top-title {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}
.title-blog, .title-news {
    background: #fff;
    border-bottom: 1px solid #ccc;
    font-size: 20px;
    line-height: 32px;
    padding: 12px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}
.wrapper-blog .card-image .image {
    padding-top: 50%
}
::-webkit-scrollbar {
  width: 3px;
}
.wrapper-top-funds {
    overflow: hidden;
}
.bl ul span{
    color: #009BDE;
    text-decoration: underline;
    display: inline-block;
    cursor: pointer;
    margin-left: 15px;
    height: 24px;
    line-height: 24px;
    overflow: hidden;
}

.bl ul span:hover{
    color: #333333;
}
.bl.useful-resources ul span:hover {
    color: #fff !important;
}
.bl.useful-resources ul li:hover:before {
    background: #fff !important;
}
.bl ul li {
    position: relative;
}
.bl ul li:before {
    content: "";
    width: 6px;
    height: 6px;
    background: #009BDE;
    position: relative;
    display: inline-block;
    position: absolute;
    top: 9px;
    left: 0;
}

.model{
    background-color:#FFF;
    position: fixed;
    top:15%;
    left:50%;
    width: 95%;
    max-width: 420px;
    margin-left: -200px;
    z-index:300;
    color:#333;
    -webkit-box-shadow: 5px 5px 50px 1px #4F4F4F;
    box-shadow: 5px 5px 50px 1px #4F4F4F;
}

@media (max-width: 768px) {
    .model{
        max-width: 95%;
        left: 2.5%;
        margin-left: 0;
        top: 5%;
    }
    .bl ul span{
        display: -webkit-box; /* Use flexbox with WebKit */
        -webkit-line-clamp: 2; /* Limit to 2 lines */
        -webkit-box-orient: vertical; /* Vertical orientation for box */
        height: auto;
    }
}

.model-icon{
    background-color:#ccc;
    padding:10px;
}

.model-head .model-close img{
    height:50px;
    float:right;

}
.model-body{
    padding:25px;
}
.model-body h2{
    font-weight:900;
    margin-bottom:20px;
}

.model-body ul {
    list-style: square;
    padding-left: 15px;
}

.model-body ul li {
    margin-bottom: 15px;
}
.wrapper-blog > .sections, .wrapper-news > .sections {
    width: 100%;
    padding-top: 55px;
}
.wrapper-twitter, .wrapper-blog, .wrapper-news {
    position: relative;
    padding: 0;
    overflow-y: scroll;
    border-radius: 15px;
    outline: none;
    border: 1px solid #4173ea;
    box-shadow: 0px 2px 4px #4f81bd;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}
.wrapper-twitter > .sections  {
    border-radius: 15px;
}
.wrapper-twitter > .sections  * {
    border: none;
    border-radius: 0;
}
.wrapper-twitter > .sections {
    border-left: none;
    border-right: none;
    border-top:  none;
}
.wrapper-twitter > .sections iframe {
    width: 100% !important;
}
.wrapper-social {
    display: flex;
}
.wrapper-social div {
    flex: 1;
    display: flex;
    flex-direction: column;
}
.title-blog, .title-twitter, .title-news {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    width: 100%;
    background: #4173ea;
    border-bottom: 1px solid #ccc;
    font-size: 20px;
    line-height: 32px;
    padding: 12px;
    color: #fff;
    position: absolute;
    top: 0;
    border-radius: 15px 15px 0 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

@media (max-width: 767px) {
    .wrapper-social {
        flex-direction: column;
    }
    .wrapper-twitter, .wrapper-blog, .wrapper-news {
        min-height: auto;
    }
    .btn-view-more {
        margin: 0 1px 20px 1px;
        padding: 20px;
        border-radius: 0 0 15px 15px;
        box-shadow: 0px 2px 4px #4f81bd;
    }
    .wrapper-blog, .wrapper-news {
        box-shadow: unset;
        border: none;
    }
    .wrapper-twitter > .sections, .wrapper-blog > .sections, .wrapper-news > .sections {
        position: static;
        overflow-y: scroll;
        transform: none;
        width: 100%;
        margin: 0;
        border-radius: 15px;
    }
}
::-webkit-scrollbar {
  width: 0;
}
@media (max-width: 400px) {
    .caption-category-mb {
        line-height: 36.44px;
    }
}

/* start - remove this css when twitter back normal*/
.wrapper-twitter-link {
    padding: 60px 30px 20px 30px;
    background: #fff;
    text-align: center;
}
.btn-twitter-link {
    display: inline-block;
    color: #fff;
    background-color: rgb(29, 155, 240);
    padding-left: 32px;
    padding-right: 32px;
    min-height: 52px;
    line-height: 52px;
    border-radius: 9999px !important;
    font-weight: 700;
    font-size: 15px;
    white-space: nowrap;
    margin: 30px auto;
}
/* end - remove this css when twitter back normal*/
.wrapper-testimonials::v-deep .VueCarousel-dot {
    background-color: #ccc !important;
}
.wrapper-testimonials::v-deep .VueCarousel-dot:focus {
    outline: none;
}
.wrapper-testimonials::v-deep .VueCarousel-dot--active {
    background-color: #4173ea !important;
}
.testimonials {
    gap: 1rem;
}
.testimonials-desc, .testimonials-name {
    color: #fff;
}
</style>
<script>
// @ is an alias to /src

import CategorySearch from "@/components/CategorySelect";
import commonMixin from "@/mixins/commonMixin";
import bannerMixin from "@/mixins/bannerMixin";
import Preloader from "@/components/Preloader";
import Disclaimer from "@/components/Disclaimer";
import TopList from "@/components/TopList";
import axios from "axios";
import HomeBlogCard from '../components/HomeBlogCard.vue';
import { mapState } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import HomeFundNewsCard from '../components/HomeFundNewsCard.vue';
import AdsGoogle from '@/components/AdsGoogle.vue';
import AdsPartner from '@/components/AdsPartner.vue';
export default {
    name: 'home',
    components: {CategorySearch, Preloader, Disclaimer, TopList, HomeBlogCard, Carousel, Slide, HomeFundNewsCard, AdsGoogle, AdsPartner },
    mixins: [commonMixin, bannerMixin],
    data() {
        return {
            showTopCategory: true,
            searchItemText: "",
            tickerModal: false,
            isLoading: false,
            activeTab:'search-keyword',
            catL:0,
            cntr: {
                f: 0,
                its: 0,
                etfs: 0
            },
            descriptionIsin: false,
            descriptionTicker: false,
            descriptionKeyword: false,
            descriptionCategory: false,
            clear:false,
            selectedCategories:{},
            catVals:{},
            dropdownText:[],
            keywordsvisible:false,
            listEquity: [],
            listBonds: [],
            listBroad: [],
            listUsefulResources: [],
            searchFocused: false,
            searchText: '',
            selectedWatchlistID : null,
            searchObject:{
                "type":null,
                "text":"",
                "code":null,
            },
            broadDisplay:{
                "etf": "funds with ETF share classes",
                "esg": "ESG funds",
                "passive": "index funds (passive)",
                "activeetfs": "Active ETFs",
                "closedendedinvestmentcompany": "investment trusts"
            },
            searchlist: [
                {search: "sector equity communications", display: "Sector Equity Communications", code: "ISA", categoryid: 'EUCA000533', type: "category"},
                {search: "isa eligible", display: "funds tradable in an ISA", code: "ISA"},
                {search: "sipp eligible", display: "funds tradable in a SIPP", code: "SIPP"},
                {search: "currency hedged", display: "funds with currency hedged share classes", code: "currency_hedged"},
                {search: "performance fee", display: "funds charging a performance fee", code: "performance_fee"},
                {search: "no performance fee", display: "funds NOT charging a performance fee", code: "no_performance_fee"},
                //{search: "esg", display: "ESG funds", code: "esg"},
                {search: "environment social governance esg", display: "ESG funds", code: "esg"},
                //{search: "", display: "funds with ETF share classes", code: "etf"},
                {search: "exchange traded etf", display: "funds with ETF share classes", code: "etf"},
                //{search: "accumulation units", display: "funds with accumulation units", code: "accumulation"},
                {search: "accumulation share class units", display: "funds with accumulation units", code: "accumulation"},
                //{search: "income units", display: "funds with income units", code: "income"},
                {search: "income units share class", display: "funds with income units", code: "income"},
                {search: "benchmark", display: "funds with a benchmark", code: "benchmark"},
                {search: "no benchmark unconstrained", display: "funds with NO benchmark (unconstrained)", code: "no_benchmark"},
                {search: "passive index", display: "index funds (passive)", code: "passive"},
                {search: "active", display: "active funds", code: "active"},
                {search: "physical replication", display: "index funds using physical replication", code: "physical"},
                {search: "discount  trusts", display: "trusts trading at a discount", code: "discount"},
                {search: "premium trusts", display: "trusts trading at a premium", code: "premium"},
                {search: "oeics", display: "OEICs", code: "Open Ended Investment Company"},//??
                {search: "investment trusts", display: "investment trusts", code: "Closed Ended Investment Company"},//??
                {search: "unit trusts", display: "unit trusts", code: "Unit Trust"},
                {search: "sicavs", display: "SICAVs", code: "SICAV"},
                {search: "open ended", display: "open ended funds", code: "Open Ended Investment Company"},
                {search: "closed ended", display: "closed ended funds", code: "Closed Ended Investment Company"},
                {search: "venture capital trusts vct", display: "VCT", code: "vct"},//??
                {search: "ev electric vehicle mobility smart next generation", display: "Electric Vehicles & Next Generation / Smart Mobility", code: "Electric Vehicles & Next Generation / Smart Mobility"},
                {search: "active etf", display: "Active ETFs", code: "Active ETFs"},
                {search: "ai artificial intelligence robotics automation", display: "AI, Robotics & Automation", code: "AI, Robotics & Automation"},
                {search: "IA investment association", display: "funds covered by the IA (Investment Association)", code: "funds covered by the IA (Investment Association)"},
                {search: "new funds today", display: "New Funds today", code: "New Funds today"},
                {search: "Low cost global equity trackers", display: "Low cost global equity trackers", code: "Low cost global equity trackers"},
                {search: "gold bullion", display: "Gold Funds", code: "Gold funds"},
                {search: "bitcoin btc", display: "Bitcoin funds (BTC)", code: "Bitcoin funds"},
                {search: "ethereum", display: "Ethereum funds (ETH)", code: "Ethereum funds"},
                {search: "s&p 500 s&p500", display: "S&P 500 index trackers", code: "S&P 500 index trackers"},
                {search: "tips", display: "US TIPS", code: "US TIPS"},
            ],
            listFunds: [],
            ListTopInvestment: [],
            listTopETFs: [],
            listTopMutual: [],
            listCategoryEquity: [],
            listCategoryBond: [],
            listCategoryAlternative: [],
            listCategoryMs: [],
            listCategoryMsWorst: [],
            listCategoryEquityWorst: [],
            listCategoryBondWorst: [],
            listCategoryAlternativeWorst: [],
            listTopMoneyMarketGBP: [],
            listTopMoneyMarketUSD: [],
            listTopMoneyMarketEUR: [],
            blogData: null,
            limitFundNews: 5,
            fundNews: null,
            testimonials:[
                {
                    desc: "I've used the site a lot reviewing my existing holdings... a very useful resource to inform decision to drop or consolidate funds and to switch new and existing between platforms, and it will be a go to resource in future.",
                    name: "Jim"
                },
                {
                    desc: "Very good site with interesting functionality that Trustnet doesn't have.",
                    name: "Ian"
                },
                {
                    desc: "A welcome resource after years trying to cross compare ITs and mutual funds and search broker sites for fund availability.",
                    name: "Jim"
                },
                {
                    desc: "Clear website and loads of searchable data.",
                    name: "Ray"
                },
                {
                    desc: "Great addition to investment information in the UK.",
                    name: "Jack"
                },
                {
                    desc: "...your brilliant site so easy to navigate for us novices unable to navigate other fund finders with success.",
                    name: "Kerry",
                }
            ],
            fltguides: [],
            fltotherusefulres: [],
            fromPartners: [],
            fltvideos: [],
        }
    },
    watch: {
        activeTab: function(value) {
            this.$store.commit("search/SET_TYPE_SEARCH", value);
        }
    },
    computed: {
        ...mapState('search', {
                effectNumber: 'effectNumber',
            }),

        myHist(){
            const storage = localStorage.getItem('searchbarHistory')
            if(storage){
                const arr = JSON.parse(storage)
                return arr.filter((item, index, self) =>
                    index === self.findIndex((t) => (
                        t.text.toLowerCase() === item.text.toLowerCase() && t.text != ""
                    ))
                )
            }
            return []
        },
        suggestions(){
            if(this.searchFocused && this.searchText.length > 0){
                const words = this.searchText.trim().split(" ");
                return this.searchlist.filter((result) => {
                    return words.every(char => result.search.toLowerCase().includes(char.toLowerCase()))
                });
            }
            return false;
        },
    },
    methods:{
        getHelOption(option){
            axios(`/help-options-information/${option}`).then(res => {
                this[option] = res.data;
            })
        },
        getPosts() {
            axios.get("/blog", {params: {page: 1, limit: 3}}).then(response => {
                if (response)
                    this.blogData = response.data
            })
        },
        getFundNews() {
            const urlGetFundNews = `/newslists/date/-1`;
            axios.post(urlGetFundNews).then(response => {
                if (response) {
                    let arrayFilter = response.data.filter(num => num.homepage);
                    this.fundNews = arrayFilter.slice(0, this.limitFundNews);
                }
            })
        },
        searchCategory(i){
            this.searchObject = null;
            this.searchObject={
                fund: i.display,
                type: i.type,
                text: i.display,
                code: [i.categoryid],
                source: 2,
            }
            this.search(this.searchObject)
        },
        handlerGoToLink(i){
            this.searchObject = null;
            if (i.type == 'isin') {
                this.searchObject = {
                    type: i.type,
                    text: i.isin,
                    code: i.isin,
                    source: 1,
                }
            } else {
                this.searchObject={
                    fund: i.category,
                    type: i.type,
                    text: i.category,
                    code: [i.categoryId],
                    source: 2,
                }
                var textValue = 'CumulativeTotalReturn1Year';
                switch(i.sortBy) {
                    case 'ytd':
                        textValue = 'CumulativeTotalReturnTD';
                        break;
                    case '3y':
                        textValue = 'TotalReturn3Years';
                        break;
                    case '5y':
                        textValue = 'TotalReturn5Years';
                        break;
                }
                this.$store.commit("search/SET_SORTING1", textValue);
            }
            this.search(this.searchObject)
        },
        classifyCats(){
            let x = ""
            let count = 0
            if(this.catVals.hasOwnProperty("fund") && this.catVals.fund != "Other" && this.catVals.fund != "" && count < 4 ){
                x=x+this.catVals.fund + " / "
                count++
            }
            if(this.catVals.hasOwnProperty("inv") && this.catVals.inv != "Other" && this.catVals.inv != "" && count < 4){
                x=x+this.catVals.inv+ " / "
                count++
            }
            if(this.catVals.hasOwnProperty("currency") && this.catVals.currency != "Other" && this.catVals.currency != "" && count < 4){
                x=x+this.catVals.currency+ " / "
                count++
            }
            if(this.catVals.hasOwnProperty("region") && this.catVals.region != "Other" && this.catVals.region != "" && count < 4){
                x=x+this.catVals.region+ " / "
                count++
            }
            if(this.catVals.hasOwnProperty("sector") && this.catVals.sector != "Other" && this.catVals.sector != "" && count < 4){
                x=x+this.catVals.sector+ " / "
            }
            if(this.catVals.hasOwnProperty("bond") && this.catVals.bond != "Other" && this.catVals.bond != "" && count < 4){
                x=x+this.catVals.bond+ " / "
                count++
            }
            if(this.catVals.hasOwnProperty("stock") && this.catVals.stock != "Other" && this.catVals.stock != "" && count < 4){
                x=x+this.catVals.stock+ " / "
                count++
            }
            if(this.catVals.hasOwnProperty("maturity") && this.catVals.maturity != "Other" && this.catVals.maturity != "" && count < 4){
                x=x+this.catVals.maturity+ " / "
                count++
            }
            if(this.catVals.hasOwnProperty("strat") && this.catVals.strat != "Other" && this.catVals.strat != "" && count < 4){
                x=x+this.catVals.strat+ " / "
                count++
            }
            if(x==""){
                return "All Categories"
            }
            else{
                return x.slice(0, -2)
            }

        },
        categoryLink(text,code){
            this.searchObject = null;
            this.$store.commit("search/SET_ACTIVECATEGORIES",code)
            this.searchObject={
                "type":"category",
                "text":text,
                "code":this.$store.state.search.activeCategories,
                "source": 3,
            }
            this.search(this.searchObject)
        },
        async categorySubmit(){
            this.searchObject = null;
            this.isLoading = true
            this.$bus.$emit("loadingPage", true)
            await this.$store.dispatch("search/getCategoriesSearchData",this.selectedCategories)
            this.searchObject={
                "fund": this.catVals.fund,
                "type":"category",
                "text":this.classifyCats(),
                "code":this.$store.state.search.activeCategories,
                "source": 2,
            }
            await this.search(this.searchObject)
            this.isLoading = false
            this.$bus.$emit("loadingPage", false)
        },
        clearCategories(){
            this.selectedCategories = {}
            this.categorySelection({})
            this.categoryVals({})
            this.clear = !this.clear
        },
        categoryVals(obj){
            Object.assign(this.catVals, obj)
        },
        async categorySelection(obj){
            Object.assign(this.selectedCategories, obj)
            this.catL = Object.keys(this.selectedCategories).length
            await this.$store.dispatch("search/getCategoriesSearch",this.selectedCategories)
        },
        onSearchInputChange (e) {
            this.searchText = e.target.value.replace(/[@#$%^*()_=+]/gi, '')
            let foundFirst = false;
            this.searchText = this.searchText.replace(/!/g, function(match, offset) {
                if (offset === 0 && !foundFirst) {
                    foundFirst = true;
                    return match;
                }
                return '';
            });
        },
        searchType() {
            this.searchObject = null;
            const re = /\b([A-Z]{2})((?![A-Z]{10}\b)[A-Z0-9]{10})\b/gi;
            const matches = this.searchText.match(re);
            if (matches) {
                this.isin = matches
                const ret = this.isin.join(',')
                this.searchObject={
                    type:"isin",
                    text:this.searchText,
                    code:ret,
                }
            }
            else {
                this.searchObject={
                    type:"text",
                    text:this.searchText,
                    code:null,
                }
            }

            this.search({...this.searchObject, source: 1})
        },
        keywordSearch(obj) {
            this.searchObject= {
                "type":"keyword",
                "text":obj.display,
                "code":obj.code,
                "keyword":this.searchText,
                "source":1,
            }
            this.search(this.searchObject)
        },
        commonSearchBroad(obj) {
            if (obj.keyword) {
                this.searchObject= {
                    "type":"keyword",
                    "text": this.broadDisplay[obj.keyword.replace(/\s/g,'').toLowerCase()] ? this.broadDisplay[obj.keyword.replace(/\s/g,'').toLowerCase()] : obj.keyword,
                    "code": obj.keyword,
                    "keyword": this.broadDisplay[obj.keyword.replace(/\s/g,'').toLowerCase()] ? this.broadDisplay[obj.keyword.replace(/\s/g,'').toLowerCase()] : obj.keyword,
                    "source":1,
                }
                this.search(this.searchObject)
            }
        },
        async search(obj){
            this.$store.commit("search/SET_PLATFORM_FILTER", null)
            this.$store.commit('search/SET_LATEST_SPREAD_BENCHMARK_DATA', null)
            this.$store.commit('search/SET_COMPARE_BENCHMARK_FILTER', {ISIN: 'GB00B3TYHH97'})
            this.isLoading = true
            this.$bus.$emit("loadingPage", true)
            await this.$store.dispatch("search/apiCall",{...obj, keyword: this.searchText})
            this.$store.commit("search/SET_ABSOLUTETOTAL", this.$store.state.search.searchData.total)
            if(obj.type != "category"){
                const { ...lastSearch } = obj;
                this.$store.commit("search/ADD_SEARCHBAR_HISTORY", lastSearch)
            }
            let textURL = '';
            if(obj.text) textURL = this.convertURL(obj.text.replaceAll('/', '*'))
            this.$store.commit("search/SET_VALUE_SEARCH_BAR", this.searchText)
            this.$store.commit("search/SET_NEW_SEARCH_SECTION", true)
            if (this.$store.state.search.searchData.ticker_search && this.$store.state.search.searchData.data.length > 1) {
                this.tickerModal = true;
            } else {
                await this.$router.push({name:"Results", params: {
                    id: this.$store.state.search.searchData.searchdata_id,
                    selectedWatchlistID: this.selectedWatchlistID,
                    text: textURL!==''?textURL:'All'}})
            }
            this.isLoading = false
            this.$bus.$emit("loadingPage", false)
        },
        renderListFunds(type ,keyword){
            var api = '';
            if (keyword) {
                api = `/search/topinvestment/${type}/${keyword}`
            } else {
                api = '/search/topfunds/' + type
            }
            var listTemp;
            switch(keyword) {
                case 'funds covered by the IA (Investment Association)':
                listTemp = 'listTopMutual';
                    break;
                case 'Closed Ended Investment Company':
                listTemp = 'ListTopInvestment';
                    break;
                case 'etf':
                listTemp = 'listTopETFs';
                    break;
                default:
                listTemp = 'listFunds';
            }
            axios.get(api).then(response => {
                if (response.error) {
                    return
                }
                this[listTemp] = [];
                var textValue = 'CumulativeTotalReturn1Year';
                switch(type) {
                    case 'ytd':
                    textValue = 'CumulativeTotalReturnTD';
                        break;
                    case '3y':
                    textValue = 'TotalReturn3Years';
                        break;
                    case '5y':
                        textValue = 'TotalReturn5Years';
                        break;
                }
                for (let i = 0; i < response.data.length; i++) {
                    let val = response.data[i];
                    this[listTemp].push({
                        name: val.FundBasicsName,
                        isin: val.ISIN,
                        value: val[textValue],
                    })
                }
            })
        },
        renderListCategoryMs(option_ntr, category_name, worst){
            var worstText = '';
            var api = `/search/topcategory/${option_ntr}/${category_name}`;
            if (worst) {
                worstText = 'Worst'
                api = `/search/worstcategory/${option_ntr}/${category_name}`;
            }
            var listTemp;

            switch(category_name) {
                case 'alternative':
                    listTemp = 'listCategoryAlternative' + worstText;
                    break;
                case 'bond':
                    listTemp = 'listCategoryBond' + worstText;
                    break;
                case 'equity':
                    listTemp = 'listCategoryEquity' + worstText;
                    break;
                default:
                    listTemp = 'listCategoryMs' + worstText;
            }
            axios.get(api).then(response => {
                if (response.error) {
                    return
                }
                this[listTemp] = [];
                for (let i = 0; i < response.data.length; i++) {
                    let val = response.data[i];
                    this[listTemp].push({
                        name: val.name,
                        categoryId: val.categoryId,
                        category:  val.name,
                        value: val.value,
                        type: 'category'
                    })
                }
            })
        },
        renderTopMoneyMarket(option_time, currency) {
            let api = `money_mkt/${option_time}/${currency}`
            axios.get(api).then(response => {
                if (response.error) {
                    return
                }
                const listTemp = `listTopMoneyMarket${currency.toUpperCase()}`;
                this[listTemp] = [];
                for (let i = 0; i < response.data.length; i++) {
                    let val = response.data[i];
                    this[listTemp].push({
                        name: val.FundBasicsName,
                        isin: val.ISIN,
                        value: val.CumulativeTotalReturnTD || val.CumulativeTotalReturn1Year || val.TotalReturn3Years || val.TotalReturn5Years || 0,
                    })
                }
            })
        },
        handleScrollToAnchor() {
            const anchor = this.$route.query.anchor;
            if (anchor) {
                let nodes = document.getElementById(anchor);
                if (nodes) {
                    let headerHeight = document.querySelector('.navbar-brand').clientHeight + 20;
                    let offsetTop = nodes.offsetTop - headerHeight;
                    window.scrollTo({
                        top: offsetTop,
                        behavior: "smooth",
                    });
                }
            }
        },
        scrollToDisclaimer() {
            var fragment = window.location.hash.split('?')[0];
            if (!fragment) return;
            var cleanFragment = fragment.substring(1);
            if (cleanFragment === 'disclaimed') {
                const disclaimer = document.getElementById(cleanFragment);
                if (!disclaimer) return;
                disclaimer.scrollIntoView({ behavior: 'smooth' });
            }
        },
        getListSuggest(){
            axios.get('/suggestions').then(response => {
                this.searchlist = response.data;
            })
        }
    },
    async mounted() {
        let fundsMobile = document.getElementById("funds-mobile");
        let fundsTablet = document.getElementById("funds-tablet");
        let itsTablet = document.getElementById("its-tablet");
        let etfsTablet = document.getElementById("etfs-tablet");

        this.selectedWatchlistID = this.$router.currentRoute.params.selectedWatchlistID;
        if(!this.effectNumber.f) {
            fundsMobile.innerHTML=0;
            itsTablet.innerHTML=0;
            etfsTablet.innerHTML=0;
            fundsTablet.innerHTML=0;
            axios.get('/search/counter').then(response => {
                const counterData = {
                    f: response.data.total_funds,
                    its: response.data.total_its,
                    etfs: response.data.total_etfs
                }
                this.cntr = counterData;
                fundsMobile.innerHTML= this.cntr.f.toLocaleString();
                fundsTablet.innerHTML= this.cntr.f.toLocaleString();
                itsTablet.innerHTML = this.cntr.its.toLocaleString();
                etfsTablet.innerHTML = this.cntr.etfs.toLocaleString();

                this.$store.commit("search/SET_EFFECT_NUMBER", counterData);
            })
        }

        this.$store.commit("search/SET_RELOAD_SEARCH", false)
        this.$store.commit("search/SET_COUNT_BASIC", 0);
        this.$store.commit("search/SET_COUNT_ADVANCE", 0);
        this.$store.commit("search/SET_CURRENCY", "gbp")
        this.$store.commit("search/SET_SHOW_SECOND_OPTION", false);
        this.$store.commit("search/SET_SORTDIR1","DESC")
        this.$store.commit("search/SET_SORTDIR2","DESC")
        this.$store.commit("search/SET_SORTING1","CumulativeTotalReturn1Year")
        this.$store.commit("search/SET_SORTING2",null)
        this.$store.commit("search/SET_FILTERS",{})
        this.$store.commit("search/SET_PROV_FILTERS",{})
        this.$store.commit("search/SET_PROVISIONAL_RES",{})
        this.$store.commit("search/SET_CURRENT_PAGE",1)
        this.$store.commit("search/SET_ACTIVECATEGORIES",[])
        this.$store.commit("auth/SET_HITTING_LIMIT", '')
        this.$store.commit("search/SET_SEARCH_RES", [])
        this.$store.commit("search/SET_ABSOLUTETOTAL", 0)
        this.clear = !this.clear;

        if(this.$store.state.compare.typeCompareDetail==="results_page" && this.$store.state.search.isBackBtnResults) {
            this.activeTab = this.$store.state.search.typeSearch;
            this.searchText= this.$store.state.search.textInSearchBar;
            Object.assign(this.selectedCategories, this.$store.state.search.lastCategories)
            this.catL = Object.keys(this.$store.state.search.lastCategories).length
            await this.$store.dispatch("search/getCategoriesSearch", this.$store.state.search.lastCategories)
            this.$store.commit("search/SET_HOMECATEGORYLIST", Object.assign({}, this.$store.state.search.homeCategoryList, this.$store.state.search.lastestSelectedCategory))
            this.$store.commit("search/SET_BACKBTN_RESULTS", false);
            const el = document.getElementById('search-funds');
            el.scrollIntoView({behavior: "smooth"});
        }
        else {
            await this.$store.dispatch("search/getCategoriesSearch",{})
        }

        this.$store.commit('shortlist/SET_SHOW_SHORTLIST',false)
        axios.get('/search/getcommonsearches').then(res => {
            this.listEquity = res.data.Equity;
            this.listBonds = res.data.Bond;
            this.listBroad = res.data.Broad;
        })

        axios.get('/usefulres').then(res => {
            this.listUsefulResources = res.data
        })
        let self = this;
        this.$nextTick(() => {
            self.handleScrollToAnchor();
        })
    },
    beforeRouteLeave (to, from, next) {
        //alert("sss")
        if(to == 'Searchlist')
        this.$toast.success("Search completed successfully")
        next();
    },
    metaInfo() {
        return {
            title: "Search Compare Invest - Over 10,000 Funds for UK Retail Investors | Pickafund",
            meta: [
                { name: 'description', content:  'Search for a Fund (by ISIN, keyword or category), compare it to its peers and find where to buy it. ETFs, ITs, Mutual Funds … Pickafund has them all'},
                { property: 'og:title', content: "Search Compare Invest - Over 10,000 Funds for UK Retail Investors | Pickafund"},
            ]
        }
    },
    created() {
        this.getListSuggest();
        this.getPosts();
        this.getFundNews();
        // undo command it when twitter can use timeline
        // let twitterFeed = document.createElement("script");
        // twitterFeed.setAttribute("src", "https://platform.twitter.com/widgets.js");
        // document.head.appendChild(twitterFeed);
        let searchData = this.$router.currentRoute.params.searchData;
        if (searchData && searchData.type == "ticker") {
            this.searchText = searchData.text;
            this.searchType();
        }
        window.addEventListener('scroll', this.handleScroll);
        this.renderListFunds('ytd', '');
        this.renderListFunds('ytd', 'Closed Ended Investment Company');
        this.renderListFunds('ytd', 'etf');
        this.renderListFunds('ytd', 'funds covered by the IA (Investment Association)');

        this.renderListCategoryMs('ytd', 'all');
        this.renderListCategoryMs('ytd', 'equity');
        this.renderListCategoryMs('ytd', 'bond');
        this.renderListCategoryMs('ytd', 'alternative');

        this.renderListCategoryMs('ytd', 'all', true);
        this.renderListCategoryMs('ytd', 'equity', true);
        this.renderListCategoryMs('ytd', 'bond', true);
        this.renderListCategoryMs('ytd', 'alternative', true);

        this.renderTopMoneyMarket('ytd', 'GBP');
        this.renderTopMoneyMarket('ytd', 'USD');
        this.renderTopMoneyMarket('ytd', 'EUR');

        this.getHelOption('fltguides')
        this.getHelOption('fltotherusefulres')
        this.getHelOption('fltvideos')
        axios(`/frompartners/asc/-1`).then(res => {
            this.fromPartners = res.data;
        })
    },
    updated() {
        this.scrollToDisclaimer();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
}
</script>
